// PanelTaskForm Component
/* eslint  react/jsx-handler-names:off */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import PanelForm from '../panel_form/panel_form.jsx'
import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import FieldDate from '../../form/field_date/field_date.jsx'
import FieldPriority from '../../form/field_priority/field_priority.jsx'
import FieldSelect from '../../form/field_select/field_select.jsx'
import FieldTextarea from '../../form/field_textarea/field_textarea.jsx'
import FieldTime from '../../form/field_time/field_time.jsx'
import FieldActions from '../../form/field_actions/field_actions.jsx'
import PanelUser from '../../panel/panel_user/panel_user.jsx'
import PopoverPlannerAssignee from '../../popover/popover_planner_assignee/popover_planner_assignee.jsx'
import PanelComment from '../../panel/panel_comment/panel_comment.jsx'
import PanelDoc from '../../panel/panel_doc/panel_doc.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PanelTaskForm extends Component {
  constructor (props) {
    super(props)

    this._references = {
      popoverPlannerAssignee: React.createRef()
    }

    this._reloadTimer = null
  }

  static get propTypes () {
    return {
      projects: PropTypes.array,
      activities: PropTypes.array,
      user: PropTypes.object,
      topUsers: PropTypes.array,
      otherUsers: PropTypes.array,
      skillOptions: PropTypes.array,
      onChange: PropTypes.func,
      onCheckUser: PropTypes.func,
      onDeleteUser: PropTypes.func,
      onSave: PropTypes.func,
      onSearchUser: PropTypes.func,
      userKeyword: PropTypes.string,
      onClick: PropTypes.func,
      onComplete: PropTypes.func,
      onReopen: PropTypes.func,
      onDelete: PropTypes.func,
      onUploadFile: PropTypes.func,
      onDeleteFile: PropTypes.func,
      task: PropTypes.object,
      skills: PropTypes.array,
      showEdit: PropTypes.object,
      onChangeDueDate: PropTypes.func,
      onChangeSkill: PropTypes.func,
      onKeyDown: PropTypes.func,
      onCreateComment: PropTypes.func,
      isViewMode: PropTypes.bool,
      onChangeDurationTime: PropTypes.func,
      onUploadError: PropTypes.func,
      onResetDuration: PropTypes.func,
      getTaskHours: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      projects: [],
      activities: [],
      user: null,
      topUsers: [],
      otherUsers: [],
      skillOptions: [],
      onChange: null,
      onCheckUser: null,
      onSave: null,
      onSearchUser: null,
      onDeleteUser: null,
      userKeyword: '',
      onClick: null,
      onComplete: null,
      onReopen: null,
      onDelete: null,
      onUploadFile: null,
      onDeleteFile: null,
      task: null,
      skills: [],
      showEdit: null,
      onChangeDueDate: null,
      onChangeSkill: null,
      onKeyDown: null,
      onCreateComment: null,
      isViewMode: false,
      onChangeDurationTime: null,
      onUploadError: null,
      onResetDuration: null,
      getTaskHours: null
    }
  }

  render () {
    const {
      task,
      topUsers,
      otherUsers,
      onComplete,
      onReopen,
      onDelete,
      userKeyword,
      onSearchUser,
      onDeleteUser,
      onUploadFile,
      onDeleteFile,
      skillOptions,
      user,
      onChange,
      onCreateComment,
      isViewMode,
      onUploadError
    } = this.props

    if (!task) {
      return null
    }

    const timeOptions = [
      {
        label: 'time.item.labelThirtyMinutes',
        title: 'time.item.titleAdd30Minutes',
        value: 30,
        name: 'labelthirty'
      },
      {
        label: 'time.item.labelOneHour',
        title: 'time.item.titleAddOneHour',
        value: 60,
        name: 'labelsixty'
      },
      {
        label: 'time.item.labelTwoHour',
        title: 'time.item.titleAddTwoHour',
        value: 120,
        name: 'labelonetwenty'
      },
      {
        label: 'time.item.labelFourHours',
        title: 'time.item.titleAddFourHours',
        value: 240,
        name: 'labeltwofourty'
      }
    ]

    return (
      <PanelForm className='panel-form panel-taskform'>
        <div className='paneltaskform maininfo'>
          <div className='paneltaskform maininfo-left'>
            <div className='info'>
              <div className='titleinfo'>
                <IntlMessage ident='plannerv2.task.editTitle' />
              </div>
              {task.id && !isViewMode && (
                <div className='taskaction'>
                  <IconButton
                    icon='x'
                    type='error'
                    label='plannerv2.task.deleteTask'
                    alignLabel='right'
                    className='actiondelete'
                    onClick={ev => (onDelete ? onDelete(task, ev) : null)}
                  />
                </div>
              )}
            </div>
            <FieldText
              name='title'
              value={task.title}
              validations={['required']}
              showEdit={false}
              autoFocus
              readOnly={isViewMode}
              onChange={
                isViewMode ? null : this._onChangeInput.bind(this, 'title')
              }
              onSave={isViewMode ? null : this._onSaveInput.bind(this, 'title')}
            />
            <FieldTitle title='plannerv2.task.editPriority' />
            <div className={`infodetail${isViewMode ? ' viewinfodetail' : ''}`}>
              <div className='priority'>
                <FieldPriority
                  active={task.priority}
                  readOnly={isViewMode}
                  onChange={
                    isViewMode
                      ? null
                      : this._onChangePriority.bind(this, 'priority')
                  }
                />
              </div>
              <div className='statusaction'>
                <FieldActions>
                  {task.completed ? (
                    <IconButton
                      icon='done'
                      type='success'
                      label='plannerv2.task.doneTask'
                      className='actioncomplete'
                      alignLabel='right'
                      onClick={ev => (onReopen ? onReopen(task, ev) : null)}
                    />
                  ) : (
                    <IconButton
                      icon='done'
                      type='disabled'
                      label='plannerv2.task.doneTask'
                      className='actioncomplete'
                      alignLabel='right'
                      onClick={ev => (onComplete ? onComplete(task, ev) : null)}
                    />
                  )}
                </FieldActions>
              </div>
            </div>
            <FieldTitle title='plannerv2.task.editDescription' />
            <FieldTextarea
              name='description'
              value={task.description}
              showEdit={false}
              readOnly={isViewMode}
              onChange={
                isViewMode
                  ? null
                  : this._onChangeInput.bind(this, 'description')
              }
              onSave={
                isViewMode ? null : this._onSaveInput.bind(this, 'description')
              }
            />
            <FieldTitle title='plannerv2.task.editProject' />
            <FieldSelect
              name='projectId'
              value={task.projectId}
              isDisabled={isViewMode}
              options={this.props.projects}
              onChange={
                isViewMode ? null : this._onChangeSelect.bind(this, 'projectId')
              }
            />
            <FieldTitle title='plannerv2.task.editActivity' />
            <FieldSelect
              name='activityId'
              value={task.activityId}
              isDisabled={isViewMode}
              options={this.props.activities}
              onChange={
                isViewMode
                  ? null
                  : this._onChangeSelect.bind(this, 'activityId')
              }
            />
            <FieldTitle title='plannerv2.task.editDuration' />
            {!isViewMode && (
              <div className='timebuttons'>
                {timeOptions.map((timeOpt, idx) => (
                  <div
                    title={IntlUtil.convertMessage(timeOpt.title)}
                    key={idx}
                    onClick={this._onIncrementTime.bind(this, timeOpt.value)}
                    className={`timebutton timebutton_${timeOpt.name}`}
                  >
                    <IntlMessage ident={timeOpt.label} />
                  </div>
                ))}
              </div>
            )}
            <FieldTime
              name='duration'
              value={task.duration}
              showEdit={false}
              readOnly={isViewMode}
              onChange={
                isViewMode ? null : this._onChangeInput.bind(this, 'duration')
              }
              onSave={
                isViewMode ? null : this._onSaveInput.bind(this, 'duration')
              }
            />
            <IconButton
              icon='reset'
              size='small'
              type='secondary'
              className='durationreset'
              canHover
              onClick={this.props.onResetDuration}
            />
          </div>
          <div className='maininfo-spliltter' />
          <div className='paneltaskform maininfo-right'>
            <FieldTitle title='plannerv2.task.editDuedate' />
            <FieldDate
              name='dueDate'
              startDate={task.dueDate}
              isViewMode={isViewMode}
              subtitle={DateUtil.getDisplayPickerDate(task.createdOn)}
              isSingleDate
              onChange={
                isViewMode ? null : this._onChangeDueDate.bind(this, 'dueDate')
              }
            />
            <FieldTitle title='plannerv2.task.editSkills' />
            <FieldSelect
              className='plannerselect'
              name='skills'
              isMulti
              defaultValue={[]}
              value={[]}
              options={skillOptions}
              isDisabled={isViewMode}
              placeholder={this._getSkillPlaceholder()}
              components={{ Option: this._renderOption }}
              onChange={this._onChangeSkill}
            />
            {!isViewMode && (
              <>
                <FieldTitle title='plannerv2.task.editSuggestedAssignee' />
                <PanelUser
                  users={topUsers}
                  onCheck={this.props.onCheckUser}
                  keyword={userKeyword}
                  onSearchUser={onSearchUser}
                  onDeleteUser={onDeleteUser}
                  onShowPopup={this._onShowAssigneePopup}
                  showSearch
                />
              </>
            )}
            {!isViewMode && (
              <>
                <div className='othersuggestions'>
                  <FieldTitle title='plannerv2.task.otherSuggestions' />
                  <IconButton
                    icon='reset'
                    size='small'
                    type='secondary'
                    className='actionreset'
                    canHover
                  />
                </div>
                <PanelUser
                  users={otherUsers}
                  onCheck={this.props.onCheckUser}
                  onShowPopup={this._onShowAssigneePopup}
                  showSearch={false}
                />
              </>
            )}
          </div>
        </div>
        <div className={classnames('paneltaskform otherinfo', { disabled: !task.id })}>
          <div className='otherinfo-splitter' />
          <div className='attachments'>
            <div className='panel-left'>
              <FieldTitle title='plannerv2.task.editAttachment' />
              <div className='text'>
                <FieldTitle title='plannerv2.task.allowedFileTypes' />
                <FieldTitle title='plannerv2.task.maxSize' />
              </div>
            </div>
            <div className='panel-right'>
              <PanelDoc
                uploadClassName='taskdocumentupload'
                items={task.documents}
                baseDownloadUrl={`/task/preview/${task.teamId}`}
                uploadSuccess={onUploadFile}
                onDelete={onDeleteFile}
                uploadError={onUploadError}
              />
            </div>
          </div>
          <div className='otherinfo-splitter' />
          <div className='comments'>
            <div className='panel-left'>
              <FieldTitle title='plannerv2.task.comments' />
              <div className='text'>
                <FieldTitle title='plannerv2.task.editComments' />
              </div>
            </div>
            <div className='panel-right'>
              <PanelComment
                user={user}
                comments={task.comments}
                onChange={onChange}
                onCreate={onCreateComment}
              />
            </div>
          </div>
          <PopoverPlannerAssignee
            ref={this._references.popoverPlannerAssignee}
            onClose={this._onCloseAssigneePopup}
          />
        </div>
      </PanelForm>
    )
  }

  /* Event handlers */
  _getSkillPlaceholder = () => {
    const { skills } = this.props
    const count = skills.length

    if (count <= 0) {
      return ''
    }

    return `${skills[0]} ${
      count > 1
        ? IntlUtil.convertMessage('plannerv2.task.selectedMoreSkills', {
            count: count - 1
          })
        : ''
    }`
  }

  _renderOption = option => {
    const { skills } = this.props

    return (
      <div
        className={classnames('css-v73v8k', 'cselect__option', {
          'cselect__option--is-focused': option.isFocused,
          'cselect__option--is-selected': skills.indexOf(option.value) >= 0
        })}
        onClick={this._onSelectSkill.bind(this, option.value)}
      >
        <div className='checkbox'>
          <div className='checkbox-inner' />
        </div>
        <span className='selecttitle'>{option.label}</span>
      </div>
    )
  }

  _onChangeSkill = (selectedSkills, ev) => {
    if (selectedSkills.length > 0) {
      this._onSelectSkill(selectedSkills[0].value, ev)
    }
  }

  _onSelectSkill = (skill, ev) => {
    const { skills, onChangeSkill } = this.props
    const idx = skills.indexOf(skill)

    if (idx >= 0) {
      skills.splice(idx, 1)
    } else {
      skills.push(skill)
    }

    if (onChangeSkill) {
      onChangeSkill(skills, ev)
    }
  }

  _onChangeInput (name, value, ev) {
    if (this.props.onChange) {
      this.props.onChange(name, value, ev)

      /* if (this._reloadTimer) {
        window.clearTimeout(this._reloadTimer);
        this._reloadTimer = null;
      }

      this._reloadTimer = window.setTimeout(() => {
        this._onSaveInput(name);
      }, 1000); */
    }
  }

  _onChangeDueDate (name, date, _toDate, ev) {
    if (this.props.onChange) {
      this.props.onChange(name, date, ev)
    }

    this._onSave(name)
  }

  _onChangeSelect (name, option, ev) {
    if (this.props.onChange) {
      this.props.onChange(name, option.value, ev)
    }

    this._onSave(name)
  }

  _onChangePriority (name, value, ev) {
    if (this.props.onChange) {
      this.props.onChange(name, value, ev)
    }

    this._onSave(name)
  }

  _onSaveInput (name) {
    this._onSave(name)
  }

  /* Private functions */
  _onSave (name) {
    if (this.props.onSave) {
      this.props.onSave(name)
    }
  }

  _onIncrementTime (value, ev) {
    const { task } = this.props

    const updateDuration = task.duration + value

    if (this.props.onChangeDurationTime) {
      this.props.onChangeDurationTime(updateDuration, ev)
    }
  }

  _onShowAssigneePopup = (user, userIndex, container) => {
    const { task, getTaskHours } = this.props

    if (this._references.popoverPlannerAssignee.current && getTaskHours) {
      getTaskHours(task.id, user.id, new Date(), task.dueDate, projects => {
        this._references.popoverPlannerAssignee.current.show(
          task,
          user,
          projects,
          container,
          userIndex
        )
      })
    }
  }

  _onCloseAssigneePopup = () => {
    if (this._references.popoverPlannerAssignee.current) {
      this._references.popoverPlannerAssignee.current.hide()
    }
  }
}

export default PanelTaskForm
